function initGardenIconsSlider() {
  const $slider = $('.garden__text-with-icons .icon-with-text-container');

  if ($(window).width() <= 798) {
    if (!$slider.hasClass('flickity-enabled')) {
      $slider.flickity({
        contain: true,
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: true
      });
    }
  } else {
    if ($slider.hasClass('flickity-enabled')) {
      $slider.flickity('destroy');
    }
  }
}

$(document).ready(initGardenIconsSlider);
$(window).on('resize', initGardenIconsSlider);